module.exports = __webpack_public_path__ + "static/media/locked.3808a548.svg";